import { AfterViewInit, Component, Inject, OnDestroy } from "@angular/core";
import { environment as env } from "../../../../environments/configs";
import { LogoutWarningSelectors } from "./logout-warning-selectors";

import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "../auth.service";
import { TIMER_START } from "../auth.token"
import { LogoutWarningActions } from "./logout-warning-actions";

@Component({
    selector: "logout-warning",
    templateUrl: "./logout-warning.component.html",
    styleUrls: ["./logout-warning.component.scss"],
})
export class LogoutWarningComponent implements AfterViewInit, OnDestroy {
    public isVisible$: Observable<Boolean>;
    public time$?: string = undefined;
    public kickout$;
    public msLeft = 0;
    public endTime = 0;
    private visibleSubscriber$;
    timer$;

    constructor(private selector: LogoutWarningSelectors,
                private authService: AuthService,
                private actions: LogoutWarningActions,
                private http: HttpClient,
                @Inject(TIMER_START) public countdown: number) {
        this.isVisible$ = this.selector.selectLogoutWarning();
    }

    public logout() {
        this.authService.logout();
        this.kickout$ = false;
    }

    ngAfterViewInit(): void {
        this.visibleSubscriber$ = this.isVisible$.subscribe((isVisible: Boolean) => {
            if (isVisible) {
                if (this.kickout$) {
                    this.kickout$ = !this.kickout$;
                }
                this.setTimes(this.countdown);
                this.calculateTime(this.countdown);
            }
        })
    }

    setTimes(time: number): void {
        this.endTime = (+new Date()) + 1000 * (time / 1000) + 500;
        this.msLeft = this.endTime - (+new Date());
    }
    twoDigits(n) {
        return (n <= 9 ? "0" + n : n);
    }
    calculateTime(time: number): void {
        let i = 0;
        while (i <= (time / 1000) + 1) {
            const _time = new Date( this.msLeft );
            this.timer$ = setTimeout(() => {
                const timeClock = new Date( this.msLeft );
                const hours = timeClock.getUTCHours();
                const mins = timeClock.getUTCMinutes();
                this.msLeft > 1000 ? this.msLeft = this.endTime - (+new Date()) : this.logout();
                this.time$ = (hours ? hours + " hours " + this.twoDigits( mins ) : mins)
                    + " min " + this.twoDigits( timeClock.getUTCSeconds() + " secs ")
            },
            (_time.getUTCMilliseconds() + 500) * i + 1);
            i++;
        }
    }
    ngOnDestroy(): void {
        this.visibleSubscriber$.unsubscribe();
        if (this.kickout$) {
            this.kickout$.unsubscribe()
        }
    }

    public refreshSession() {
        this.http.get(`${env.apiPath}/refresh`, { observe: "response" })
            .subscribe((res) => {
                const accessToken = res.headers.get("access_token")!;
                this.authService.setAuthentication(accessToken);
                this.actions.setInVisible();
                if (this.kickout$) {
                    this.kickout$.unsubscribe()
                }
            },
        (error) => this.logout());
        window.clearTimeout(this.timer$);
    }

}
